import { styled } from '@mui/material/styles';
import React from 'react';
import PropTypes from 'prop-types';

import { useAppContext } from '../hooks/AppProvider';

const StyledLink = styled('a')(({ theme }) => ({
  position: 'absolute',
  top: -40,
  left: 0,
  background: theme.palette.background.default,
  color: theme.palette.text.primary,
  padding: theme.spacing(1, 2),
  zIndex: 10000,
  textDecoration: 'none',
  fontSize: '0.875rem',
  '&:focus': {
    top: 0,
    outline: `2px solid ${theme.palette.text.primary}`,
    outlineOffset: -2,
  },
}));

const SkipLink = ({ targetId = 'main-content' }) => {
  const { reducedMotion } = useAppContext();

  const handleClick = (e) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const scrollTarget = targetElement.querySelector('h1') || targetElement;
      const headerOffset = document.querySelector('header')?.offsetHeight || 0;
      const top = scrollTarget.getBoundingClientRect().top + window.scrollY - headerOffset;

      targetElement.focus({ preventScroll: true });
      window.scrollTo({
        top: Math.max(0, top),
        behavior: reducedMotion ? 'instant' : 'smooth',
      });
    }
  };

  return(
    <StyledLink href={`#${targetId}`} onClick={handleClick}>
      Zum Hauptinhalt springen
    </StyledLink>
  );
};

SkipLink.propTypes = {
  targetId: PropTypes.string,
};

export default SkipLink;
